import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import axios from 'axios';
interface EditEmailDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (newEmail: string, otps: { currentOtp: string; newOtp: string }) => void;
  currentEmail: string;
}
const EditEmailDialog: React.FC<EditEmailDialogProps> = ({ open, onClose, onSave, currentEmail }) => {
  const [newEmail, setNewEmail] = useState(currentEmail);
  const handleSave = async () => {
    try {
      const response = await axios.post('http://localhost:3080/v1/labs/sim/ops/account/email/otp', {
        currentEmail,
        newEmail,
      });
      onSave(newEmail, response.data.data);
    } catch (error) {
      toast.error('Failed to send OTPs. Please try again.');
    }
  };
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullWidth
      PaperProps={{
        style: {
          width: '40%', 
          maxWidth: 'none',
          padding: '10px'
        }
      }}
    >
      <DialogTitle>Please enter new email:</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="New Email"
          value={newEmail}
          style={{ marginTop: '5px' }}
          onChange={(e) => setNewEmail(e.target.value)}
        />
      </DialogContent>
      <DialogActions style={{ margin: '-10px 12px 10px 0' }}>
        <Button onClick={handleSave} color="primary">Check OTP</Button>
      </DialogActions>
    </Dialog>
  );
};
export default EditEmailDialog;